// extracted by mini-css-extract-plugin
export default {"title":"ResetPassword_title__jaqdG","secondary":"ResetPassword_secondary__i9F1R","logo":"ResetPassword_logo__Ckguc"};